import { FC, Key } from 'react';
import { ProInput } from '../antd';
import SuperSelectTable from '../SuperSelectTable';
import SearchFormItem from './subpage/searchFormItem';
import { getSelectPlaceholder } from '../utils/ruleUtils';
import { SuperSelectTableProps } from '../SuperSelectTable/interface';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';
import { FormInstance } from 'antd/lib/form';
import { DEFAULT_FIELD_NAMES } from '../SuperSelect/interface';
import { NodeKey } from '../constants/interface';

export interface SearchFormSuperSelectTableProps extends BaseSearchFormItemProps {
  /** label对应的字段名 */
  labelKey?: string;
  /** value对应的字段名 */
  valueKey?: string;
  /** superSelectTable Props */
  superSelectTableProps?: SuperSelectTableProps;
}
/** 下拉表格 */
export const SearchFormSuperSelectTable: FC<SearchFormSuperSelectTableProps> = props => {
  const {
    superSelectTableProps,
    isDetail,
    form,
    render,
    disabledRender,
    isTable,
    name,
    testId,
    label,
    rules,
    copy,
    routeLinkProps,
    ...resProps
  } = props;
  if (!superSelectTableProps) return null;
  let valueName: NodeKey | undefined = '';
  let labelName: NodeKey | undefined = '';
  if (Array.isArray(name)) {
    valueName = name[0];
    labelName = name[1];
  } else {
    valueName = name;
  }
  const handleBeforeFetch = (params: any) => {
    if (!superSelectTableProps.beforeFetch) return params;
    return superSelectTableProps.beforeFetch?.(params, form?.getFieldsValue(true));
  };
  const handleChange = (value: any, item: any, _?: FormInstance, index?: number) => {
    if (superSelectTableProps.mode === 'multiple') {
      if (labelName)
        form?.setFieldsValue({
          [labelName]: item?.map((v: any) => v[superSelectTableProps.labelKey || DEFAULT_FIELD_NAMES.label]),
        });
    } else {
      if (labelName)
        form?.setFieldsValue({
          [labelName]: item?.[superSelectTableProps.labelKey || DEFAULT_FIELD_NAMES.label],
        });
    }
    superSelectTableProps.onChange?.(value, item, form, index);
  };

  return (
    <>
      <SearchFormItem
        {...resProps}
        name={valueName}
        label={label}
        rules={rules}
        validateTrigger="onChange"
      >
        <SuperSelectTable
          style={{ width: '100%' }}
          disabledRender={render || disabledRender}
          copy={copy}
          routeLinkProps={routeLinkProps}
          {...superSelectTableProps}
          disabled={isDetail || superSelectTableProps.disabled}
          placeholder={getSelectPlaceholder(label, superSelectTableProps, rules)}
          beforeFetch={handleBeforeFetch}
          onChange={handleChange}
          test-id={`${testId}-${valueName}`}
        />
      </SearchFormItem>
      {!!labelName && (
        <SearchFormItem
          hidden={true}
          name={labelName}
          style={{ padding: 0, margin: 0 }}
        >
          <ProInput />
        </SearchFormItem>
      )}
    </>
  );
};

SearchFormSuperSelectTable.displayName = SearchFormItemEnum.SearchFormSuperSelectTable;

export default SearchFormSuperSelectTable;
